import React, { useContext } from 'react'
import { ChangePresentContext, OpsPlanContext } from '../../../SingleEvent'
import { Grid, TextField } from '@mui/material'
import PresetsTextField from '../../../../../../components/Forms/PresetsTextField'

const VehicleMovements = () => {
  const { opsPlan, setOpsPlan } = useContext(OpsPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        multiline
        value={opsPlan?.vehicleMovements}
        minRows={2}
        label="Vehicle Movements"
        fullWidth
        suggestionPath="opsPlan.vehicleMovements"
        suggestionLabel="Vehicle movement notes from templates"
        setValue={(newValue) => {
          setOpsPlan((prev) => ({
            ...prev,
            vehicleMovements: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!opsPlan?.vehicleMovements,
        }}
      />
    </Grid>
  )
}
export default React.memo(VehicleMovements)
